// extracted by mini-css-extract-plugin
export var card = "travelCard-module--card--0jOJF";
export var content = "travelCard-module--content--m1oJi";
export var picture = "travelCard-module--picture--c-GVb";
export var title = "travelCard-module--title--xS6wG";